import React, { useState, useEffect } from "react";
import "./Footer.css";
import { Link, useNavigate } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCrown,
  faFilePen,
  faHouse,
  faInfoCircle,
  faPhone,
  fas,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faInstagram,
  faFacebook,
  faTwitter,
  faXTwitter,
  faLinkedinIn,
  faFacebookF,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

import Cookies from "js-cookie";
import { useContext } from "react";
import { Context } from "../../utils/context";
import NotificationModal from "../CommonPage/NotificationPage/NotificationModal";
import Login_As_Modal from "../CommonPage/Login_As_Modal/Login_As_Modal";

library.add(fas);

const Footer = () => {
  const navigate = useNavigate();
  const [showIcons, setShowIcons] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [icon, setIcon] = useState("+");
  const toggleIcons = () => {
    setShowIcons(!showIcons);
    setIcon(showIcons ? "+" : "x");
  };

  const {
    ReactLoader,
    setReactLoader,
    getData,
    setSignin,
    signin,
    setUsertype,
    userType,
    userdata,
  } = useContext(Context);

  const [authToken, setAuthToken] = useState(null);
  const [authType, setAuthType] = useState(null);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const browseJob = () => {
    navigate("/", {
      state: { scrollToFeatured: true },
    });
  };

  useEffect(() => {
    if (signin) {
      setAuthToken(Cookies.get("echohouse_website"));
      setAuthType(Cookies.get("jwtType"));
    } else {
      setAuthToken(null);
      setAuthType(null);
    }
    setReactLoader(false);
  }, [signin, userType]);

  const [shownotificationModal, setNotificationmodal] = useState(false);

  return (
    <div className="custom-job-footer-wrapper">
      {/* desktop-view-start */}
      <section className="footer desktop-view-footer">
        <div className="container">
          
          {/* TOP LINKS SECTION */}
          <div className="row footer_upper_content pt-5 pb-4">
            {/* Column 1: Job Categories */}
            <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 mb-4">
              <h6>Job Categories</h6>
              <ul>
                <li><Link to={`/jobexp`}>Jobs By Location</Link></li>
                <li><Link to={`/jobexp`}>Jobs By Skill</Link></li>
                <li><Link to={`/jobexp`}>Jobs By Title</Link></li>
                <li><Link to={`/jobexp`}>Jobs By Function</Link></li>
                <li><Link to={`/jobexp`}>Jobs By Industry</Link></li>
                <li><Link to={`/jobexp`}>Jobs By Education</Link></li>
                <li><Link to={`/jobexp`}>Jobs By Other</Link></li>
              </ul>
            </div>

            {/* Column 2: Employers */}
            <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 mb-4">
              <h6>Employers</h6>
              <ul>
                {authToken === null && (
                  <li>
                    <Link to="/getotp">Employer Login</Link>
                  </li>
                )}
                
                {authToken === null ? (
                  <li>
                    <Link to="/getotp">Job Posting</Link>
                  </li>
                ) : userdata?.type === "Recruiter" ? (
                  <li>
                    <Link to="/dashboardmain">Job Posting</Link>
                  </li>
                ) : (
                  <li>
                    <p className="clickable-span-item" onClick={() => setModalShow(true)}>Job Posting</p>
                  </li>
                )}
                <li><Link to="/">Access Resume Database</Link></li>
                <li><Link to="/">Join mRecruiters</Link></li>
                <li><Link to="/getotp">Buy Online</Link></li>
              </ul>
            </div>

            {/* Column 3: Job Seekers */}
            <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 mb-4">
              <h6>Job Seekers</h6>
              <ul>
                {authToken === null && (
                  <li>
                    <Link to="/getotp-jobseeker">Upload Resume</Link>
                  </li>
                )}
                <li><Link to="/career-services">Search Tips</Link></li>

                {authToken === null ? (
                  <li>
                    <Link to="/getotp">Find Companies</Link>
                  </li>
                ) : userdata?.type === "Job Seeker" ? (
                  <li>
                    <Link to="/dashboard-job">Find Companies</Link>
                  </li>
                ) : (
                  <li>
                    <p className="clickable-span-item" onClick={() => setModalShow(true)}>Find Companies</p>
                  </li>
                )}
                
                {authToken !== null && (
                  <li>
                    <Link onClick={() => setNotificationmodal(true)}>Notifications</Link>
                  </li>
                )}
                {authToken === null && (
                  <li>
                    <Link to="/getotp-jobseeker">Notifications</Link>
                  </li>
                )}
                <li><Link to="/help">Help</Link></li>
              </ul>
            </div>

            {/* Column 4: Company Info */}
            <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 mb-4">
              <h6>Company Info</h6>
              <ul>
                <li><Link to="/aboutUs" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>About Us</Link></li>
                <li><Link append to="/contact" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Contact Us</Link></li>
                <li><Link to="/feedback">Send Feedback</Link></li>
                <li><Link to="/blogs">Blog</Link></li>
              </ul>
            </div>

            {/* Column 5: IT Jobs */}
            <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 mb-4">
              <h6>IT Jobs</h6>
              <ul>
                <li><Link to={`/jobexp`}>Software testing</Link></li>
                <li><Link to={`/jobexp`}>SQL</Link></li>
                <li><Link to={`/jobexp`}>Oracle</Link></li>
                <li><Link to={`/jobexp`}>Graphic Design</Link></li>
                <li><Link to={`/jobexp`}>Digital marketing</Link></li>
              </ul>
            </div>

            {/* Column 6: Non IT Jobs */}
            <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 mb-4">
              <h6>Non IT Jobs</h6>
              <ul>
                <li><Link to={`/jobexp`}>HR</Link></li>
                <li><Link to={`/jobexp`}>Sales</Link></li>
                <li><Link to={`/jobexp`}>Accounting</Link></li>
                <li><Link to={`/jobexp`}>Call Center</Link></li>
                <li><Link to={`/jobexp`}>Electrical engineering</Link></li>
                <li><Link to={`/jobexp`}>Event management</Link></li>
              </ul>
            </div>
          </div>

          <hr className="footer-divider" />

          {/* MIDDLE UTILITIES SECTION */}
          <div className="row footer_middle_content align-items-center py-4">
            {/* Selected Country */}
            <div className="col-xl-4 col-lg-4 col-md-6 mb-4 mb-lg-0">
              <label className="footer-label">Selected Country</label>
              <div className="country-dropdown-wrapper">
                <select className="form-select country-select" defaultValue="India">
                  <option value="India">India</option>
                </select>
              </div>
            </div>

            {/* Stay Connected */}
            <div className="col-xl-4 col-lg-4 col-md-6 mb-4 mb-lg-0">
              <label className="footer-label">Stay Connected</label>
              <div className="social-icons-row">
                <Link target="_blank" to="https://www.facebook.com/people/Placement-Platform/61558332110223/"><FontAwesomeIcon icon={faFacebookF} /></Link>
                <Link target="_blank" to="https://x.com/"><FontAwesomeIcon icon={faXTwitter} /></Link>
                <Link target="_blank" to="https://in.linkedin.com/"><FontAwesomeIcon icon={faLinkedinIn} /></Link>
                <Link target="_blank" to="https://www.instagram.com/placementplatform/?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw%3D%3D#"><FontAwesomeIcon icon={faInstagram} /></Link>
                <Link target="_blank" to="https://www.youtube.com/"><FontAwesomeIcon icon={faYoutube} /></Link>
              </div>
            </div>

            {/* 24/7 Support with User's Requested Contact Data */}
            <div className="col-xl-4 col-lg-4 col-md-6 mb-4 mb-lg-0">
              <label className="footer-label">Contact & Support</label>
              <div className="support-info">
                <p className="mb-2 address-text-layout">
                  <FontAwesomeIcon icon="fa-solid fa-location-dot" className="me-2 " />
                  1st Floor, Office No 1, M No. 734, Pashan Rd, opp. High Class Society, near Suryadatta College of Management, Patil Nagar, Bavdhan, Pune, Maharashtra 411021
                </p>
                <p className="mb-1"><b>PIN Code:</b> 411021</p>
                <p className="mb-1">
                  <FontAwesomeIcon icon="fa-solid fa-phone" className="me-2" /> 
                  <a href="tel:96077755557" className="tel-link">+91 960 775 5557</a> / <a href="tel:9405709042" className="tel-link">+91 940 570 9042</a>
                </p>
                <p>
                  <a href="https://mail.google.com/mail/?view=cm&fs=1&to=info@profcymaglobal.com" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon="fa-solid fa-envelope" className="me-2" /> info@profcymaglobal.com
                  </a>
                </p>
              </div>
            </div>

            
          </div>

          <hr className="footer-divider" />

          {/* BOTTOM META LINKS & COPYRIGHT */}
          <div className="row footer_bottom_content py-3 align-items-center">
            <div className="col-md-8 text-start mb-3 mb-md-0">
              <div className="bottom-legal-links">
                <Link to="/safe-job-search">Security & Fraud</Link> | 
                <Link to="/privacy">Privacy Policy</Link> | 
                <Link to="/terms">Terms of Use</Link> | 
                <Link to="/safe-job-search">Be Safe</Link> | 
                <Link to="/help">Complaints</Link> | 
                <Link to="/safe-job-search">Beware of Fraudsters</Link>
              </div>
            </div>
            <div className="col-md-4 text-md-end text-start">
              <span className="copyright-text">
                © 2026 Placement Platform | Developed by <Link to="https://profcymaglobal.com/" target="_blank" style={{color: '#928cb3', textDecoration: 'none'}}>Profcyma Solutions Pvt Ltd</Link>
              </span>
            </div>
          </div>

        </div>
      </section>

     

      {/* MODALS */}
      <NotificationModal
        show={shownotificationModal}
        onHide={() => setNotificationmodal(false)}
      />

      <Login_As_Modal
        text={
          userdata?.type === "Recruiter"
            ? "Login As Job Seeker"
            : "Login As Recruiter"
        }
        loginRoute={
          userdata?.type === "Recruiter" ? "/getotp-jobseeker" : "/getotp"
        }
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </div>
  );
};

export default Footer;